import i18n, { getLanguageFromLocale } from 'locale';
import { resolveSiteUrl, resolveStaticsUrl } from './urlBuilder';

type ResourceName = 'terms' | 'privacy';
type Langs = 'pl' | 'en';

const urlMap: Record<ResourceName, Record<Langs, string>> = {
	terms: {
		pl: '/terms-of-service/RegulaminAplikacjiMentiway.pdf',
		en: '/terms-of-service/MentiwayTermsOfUse.pdf',
	},
	privacy: {
		pl: '/polityka-prywatnosci',
		en: '/polityka-prywatnosci',
	},
};

export const translatedStaticResourceResolver = (name: ResourceName, lang?: string) => {
	const finalLang: Langs = (lang || i18n.language) as Langs;
	let langCode = getLanguageFromLocale(finalLang) as 'pl' | 'en';

	if (!Object.keys(urlMap[name]).includes(langCode)) {
		langCode = 'en';
	}

	const url = urlMap[name][langCode] || '/';

	switch (name) {
		case 'terms':
			return resolveStaticsUrl(url);
		case 'privacy':
			return resolveSiteUrl(url);
		default:
			return '/';
	}
};

export const getBlogUrl = (lang?: string) => {
	const finalLang = lang || i18n.language;
	const langCode = getLanguageFromLocale(finalLang);

	if (langCode === 'pl') {
		return 'https://mentiway.com/blog/';
	}

	return `https://mentiway.com/${langCode}/blog/`;
};

export const getLinkedInUrl = () => {
	return 'https://www.linkedin.com/company/mentiway/';
};
